import React, { ReactNode } from "react";

import {
  StyledInfoBoxContainer,
  StyledInfoBoxHeader,
  StyledInfoBoxWrapper,
  SyledInfoBoxInnerHeader,
} from "./Styles";
import { colors } from "../../utils";
import { CheckboxBlankTogglerIcon, CloseCircleIcon, InfoIcon } from "../Icons";
import { ElementWithRef } from "../Select";
import { Body2 } from "../Typography";
export type InfoBoxType =
  | "success"
  | "warning"
  | "note"
  | "default"
  | "neutral";
export interface InfoBoxProps {
  type: InfoBoxType;
  children?: ReactNode;
  showIcon?: boolean;
  title?: ReactNode | string;
  icon?: ElementWithRef<SVGSVGElement>;
  action?: ReactNode;
}
export const InfoBox: React.FC<InfoBoxProps> = ({
  type = "default",
  children,
  showIcon,
  icon,
  title = null,
  action = null,
  ...rest
}) => {
  const statusColors: Record<InfoBoxType, string> = {
    success: colors.greenSuccess.color,
    warning: colors.redAlert.color,
    note: colors.yellowWarning.color,
    default: colors.blueSky.color,
    neutral: colors.gray.color,
  };
  // https://davidwalsh.name/hex-opacity
  const opacity = "1A";

  return (
    <StyledInfoBoxWrapper
      $color={`${statusColors[type]}`}
      $opacity={opacity}
      {...rest}
    >
      <StyledInfoBoxContainer>
        {showIcon && (
          <span>
            {icon && React.isValidElement(icon) ? (
              React.cloneElement(icon, {
                fill: statusColors[type],
                width: 18,
              })
            ) : type === "success" ? (
              <CheckboxBlankTogglerIcon fill={statusColors[type]} width={18} />
            ) : type === "warning" ? (
              <CloseCircleIcon fill={statusColors[type]} width={18} />
            ) : type === "note" || type === "default" ? (
              <InfoIcon fill={statusColors[type]} width={18} />
            ) : (
              <InfoIcon fill={statusColors["neutral"]} width={18} />
            )}
          </span>
        )}
        <StyledInfoBoxHeader $hasTitle={title ? true : false}>
          <SyledInfoBoxInnerHeader>
            {typeof title === "string" && title ? (
              <Body2 weight="bold" lineHeight="loose">
                {title}
              </Body2>
            ) : (
              title
            )}
            {action}
          </SyledInfoBoxInnerHeader>
          {children}
        </StyledInfoBoxHeader>
      </StyledInfoBoxContainer>
    </StyledInfoBoxWrapper>
  );
};
